
import { Options, Vue }    from 'vue-class-component';
import BaseImageInput from '../components/shared/base-image-input.vue';
import infoButton from '../components/shared/info-button.vue';

@Options({
  components: {
    BaseImageInput,
    infoButton
  },
  data() {
    return {
      imageFile: null,
      preview1: './img/house-presets/d1-prew.jpg',
      preview2: './img/house-presets/d2-prew.jpg',
      preview3: './img/house-presets/d3-prew.jpg'
    }
  }
})

export default class StartPage extends Vue {

  selectPreset(presetNumber: number) {
    const preset = [
      './img/house-presets/d1.jpg',
      './img/house-presets/d2.jpg',
      './img/house-presets/d3.jpg'
    ][presetNumber];

    this.$store.commit('setPreviewImageUrl', preset);
    this.$store.commit('setAutomatedGuideFlow', true);

    this.$router.push({ path: '/configure'});
  }
}
